/**
 * Task templates API slice.
 * Leaf module (Perf 3.1.b/e Step 5). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const taskTemplatesApi = {
  fetchCategories: async () => {
    const data = await fetchWithAuth('/json/task-templates/categories');
    if (data.error) {
      throw new ApiError(data.message || 'Failed to fetch template categories', 400, data);
    }
    // Handle both wrapped ({ data: { categories } }) and unwrapped ({ categories }) responses
    return data.data?.categories || data.categories || [];
  },

  fetchTemplates: async ({ category, featured } = {}) => {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (featured) params.append('featured', 'true');
    const url = `/json/task-templates${params.toString() ? '?' + params : ''}`;
    const data = await fetchWithAuth(url);
    if (data.error) {
      throw new ApiError(data.message || 'Failed to fetch templates', 400, data);
    }
    // Handle both wrapped and unwrapped responses
    const result = data.data || data;
    return {
      templates: result.templates || [],
      categories: result.categories || [],
    };
  },

  fetchTemplate: async (slug) => {
    const data = await fetchWithAuth(`/json/task-templates/${slug}`);
    if (data.error) {
      throw new ApiError(data.message || 'Failed to fetch template', 400, data);
    }
    // Handle both wrapped and unwrapped responses
    return data.data?.template || data.template;
  },

  createTaskFromTemplate: async (payload) => {
    const data = await fetchWithAuth('/json/inference-tasks/from-template', {
      method: 'POST',
      body: payload,
    });
    if (data.error) {
      throw new ApiError(data.message || 'Failed to create task from template', 400, data);
    }
    // Handle both wrapped ({ data: { task } }) and unwrapped ({ task }) responses
    return data.data || data;
  },

  favoriteTemplate: async (templateId) => {
    const data = await fetchWithAuth(`/json/user/me/favorite-task-templates/${encodeURIComponent(templateId)}`, {
      method: 'POST',
    });
    if (data.error) throw new ApiError(data.message || 'Failed to favorite template', data.status || 400, data);
    return !data.error;
  },

  unfavoriteTemplate: async (templateId) => {
    const data = await fetchWithAuth(`/json/user/me/favorite-task-templates/${encodeURIComponent(templateId)}`, {
      method: 'DELETE',
    });
    if (data.error) throw new ApiError(data.message || 'Failed to unfavorite template', data.status || 400, data);
    return !data.error;
  },
};
